/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { Button, FormControl, InputAdornment } from "@material-ui/core";
import { ThemeCustomInputField } from "../../../../shared/themeComponents/themeCustomInputField";
import { HiOutlineMail } from "react-icons/hi";
import { EmailVerificationSignUpProps } from "../../../../../@types/components/signupV2.types";

import "./emailVerification.scss";

const mailformat = /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/;

const EmailVerification = ({
	handleSubmit,
	OTPVerified,
	handleChange,
	validationUserId,
	emailExists,
	resendOTPButtonVisible,
	userEmail,
	resentOTPCaptionVisible,
	handleSendOTPToEmailClick,
	startTimer,
	OTP,
	timer,
	handleOTPChange,
	handleVerifyOTPClick
}: EmailVerificationSignUpProps) => {
	// console.log(
	// 	"resendOTPButtonVisible",
	// 	resendOTPButtonVisible,
	// 	"\n userEmail.match(mailformat) :",
	// 	userEmail,
	// 	"\nOTPVerified ",
	// 	OTPVerified
	// );

	return (
		<div className="email-verification-main-container">
			<form onSubmit={handleSubmit} autoComplete="off" method="">
				<FormControl className="form-container" id="form-container">
					{/* EMAIL AND USERNAME INPUT */}
					<span className="form-input-label">Email</span>
					<ThemeCustomInputField
						className="form-field-input"
						style={{
							width: 400,
							borderRadius: 5,
							cursor: userEmail !== "" && !emailExists ? "auto" : "not-allowed"
						}}
						disabled={
							startTimer === true
								? true
								: OTPVerified === true
								? true
								: resentOTPCaptionVisible === true
								? true
								: false
						}
						label=""
						name="email"
						variant="outlined"
						value={userEmail}
						placeholder="Enter your email address"
						onChange={handleChange}
						helperText={emailExists ? "Email exists!" : validationUserId}
						InputProps={{
							endAdornment: (
								<InputAdornment position="start">
									<HiOutlineMail style={{ color: "#a06cd5", fontSize: 25 }} />
								</InputAdornment>
							)
						}}
					/>
					{/* SEND AND RESEND OTP */}
					{resendOTPButtonVisible && userEmail.match(mailformat) && !OTPVerified ? (
						<Button
							className="send-otp-button"
							variant="contained"
							onClick={handleSendOTPToEmailClick}
							style={{
								backgroundColor: "#8C68E1",
								color: "#ffff",
								padding: 10,
								width: 400,
								border: "none",
								boxShadow: "none",
								fontWeight: 300
							}}
						>
							<span className="button-label-with-icon" style={{ color: "#ffff", fontSize: 15 }}>
								{resentOTPCaptionVisible ? "Resend\xa0OTP" : "Send\xa0OTP"}
							</span>
						</Button>
					) : null}
					{/* OTP FIELD APPEARS */}
					{startTimer && !OTPVerified ? (
						<div className="otp-container">
							<span className="form-input-label">OTP</span>
							<div className="otp-input-container">
								<ThemeCustomInputField
									className="form-field-input"
									style={{ width: 270, borderRadius: 5 }}
									label=""
									name="OTP"
									value={OTP}
									variant="outlined"
									placeholder="Please enter the OTP"
									onChange={handleOTPChange}
									helperText={
										startTimer ? timer.minutes + ":" + timer.seconds + " before expiration" : ""
									}
								/>
								<Button
									className="login-button"
									variant="contained"
									onClick={handleVerifyOTPClick}
									style={{
										backgroundColor: "#8C68E1",
										color: "#ffff",
										padding: 10,
										width: 100,
										fontSize: 10,
										border: "none",
										boxShadow: "none",
										textAlign: "center"
									}}
									disabled={OTP === "" ? true : false}
								>
									<span className="button-label-with-icon" style={{ color: "#ffff", fontSize: 15 }}>
										VERIFY
									</span>
								</Button>
							</div>
						</div>
					) : null}
				</FormControl>
			</form>
		</div>
	);
};

export default EmailVerification;
